<template>
  <div class="text-sm leading-5 text-sand-40">
    <div
      v-if="footer.leftColumn?.content"
      class="font-light max-lg:text-white"
      @click="contentLink"
      v-html="footer.leftColumn.content"
    />
  </div>
</template>

<script setup lang="ts">
const { footer } = useGeneralInternalStore();
const contentLink = useContentLink;
</script>
